import type { Account } from "@/views/account/account";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Account) {
  entity._authRequestFields = ["id", "statusMurn"];
  return entity;
}

function getInitialData() {
  const result = {} as Account; //TODO: ts
  return addAuthRequestFields(result);
}

async function skinnyResponseAdapter(response: { data: Account }) {
  addAuthRequestFields(response.data);
  return response.data;
}

async function responseAdapter(response: { data: Account }) {
  response.data = await skinnyResponseAdapter(response);
  return response.data;
}

function requestAdapter(data: Account) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Account) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Account) {}
